



















































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Form, FormQuestion, Patient } from "@/store/modules/types";
import moment from "moment";


@Component
export default class FormViewerPdf extends Vue {
  @Prop() readonly form!: Form;
  @Prop(Array) readonly questions!: Array<FormQuestion>;
  @Prop({ default: null }) readonly patient!: Patient;

  @Watch("entityId")
  onEntityChanged() {
    console.log("entity changed");
    this.updatedEntity();
  }

  entityName = "";
  logoId = null;

  parseDateTime(value: any) {
    try {
      if (!value) return { formatted: null, date: null };
      console.log(value);
      let obj: any = null;

      if (typeof value === "string") {
        try {
          obj = JSON.parse(value);
        } catch {

          const parsed = moment(value);
          if (!parsed.isValid()) return null;

          return {
            date: parsed.format("YYYY-MM-DD"),
            time: parsed.format("HH:mm"),
            fullDateTime: parsed.toISOString(),
            formatted: parsed.format("MMM D, YYYY hh:mm A"),
          };
        }
      } else {
        obj = value;
      }


      if (!obj || !obj.date) return null;

      const fullDateTime = obj.time
        ? `${obj.date.split("T")[0]}T${obj.time}`
        : obj.date;

      return {
        date: obj.date,
        time: obj.time ?? null,
        fullDateTime,
        formatted: moment(fullDateTime).format("MMM D, YYYY hh:mm A"),
      };
    } catch (e) {
      console.error("Error parsing DateTimeAnswer:", e);
      return null;
    }
  }

  parseDate(value) {
    const parsed = this.parseDateTime(value);

    if (!parsed || !parsed.date) return "—";

    return moment(parsed.date).format("MMM D, YYYY");
  }

  formatTime(value: string) {
    if (!value) return "";

    const formats = [
      "HH:mm:ss",
      "HH:mm",
      "hh:mm A",
      "hh:mm:ss A",
      moment.ISO_8601
    ];

    const parsed = moment(value, formats, true);

    if (!parsed.isValid()) return value; 

    return parsed.format("hh:mm A");
  }



  parseDateTimeAnswerX(answerValue: any) {
    try {
      if (!answerValue) return { formatted: null, date: null };

      const obj =
        typeof answerValue === "string" ? JSON.parse(answerValue) : answerValue;

      if (!obj?.date) {
        return { date: answerValue }
      }

      const fullDateTime = obj.time
        ? `${obj.date.split("T")[0]}T${obj.time}`
        : obj.date;

      return {
        date: obj.date,
        time: obj.time || null,
        fullDateTime,
        formatted: moment(fullDateTime).format("MMM D, YYYY hh:mm A"),
      };
    } catch (e) {
      console.error("Error parsing DateTimeAnswer:", e);
      return null;
    }
  }

  parseDateTimeAnswerBK(answerValue: any) {
    try {
      if (!answerValue) return { formatted: null, date: null };

      const obj =
        typeof answerValue === "string" ? JSON.parse(answerValue) : answerValue;

      if (!obj?.date) return null;

      const fullDateTime = obj.time
        ? `${obj.date.split("T")[0]}T${obj.time}`
        : obj.date;

      return {
        date: obj.date,
        time: obj.time || null,
        fullDateTime,
        formatted: moment(fullDateTime).format("MMM D, YYYY hh:mm A"),
      };
    } catch (e) {
      console.error("Error parsing DateTimeAnswer:", e);
      return null;
    }
  }

  parseMultipleChoiceAnswer(answerValue: any) {
    if (!answerValue) return [];
    const options =
      typeof answerValue === "string" ? JSON.parse(answerValue) : answerValue;

    return options;

  }

  get logoURL(): string | null {
    if (!this.logoId) return null;

    return `${process.env.VUE_APP_ROOT_API}/schedule/wmpc/content/file/${this.logoId}`;
  }

  getAge(birthDate: string | null | undefined): string | null {
    if (!birthDate || birthDate.trim() === "") return null;

    const date = moment(birthDate);
    if (!date.isValid()) return null;

    const years = moment().diff(date, "years");
    return years + " years";
  }

  get entityId() {
    return this.$store.state.auth.entityId;
  }



  updatedEntity() {
    const { entities } = this.$store.state.auth.user;
    //const entityId = this.$store.state.auth.entityId;
    const { logoId, name } = entities.find((e: any) => e.id === this.entityId);
    this.logoId = logoId;
    this.entityName = name;
  }


  mounted() {
    this.updatedEntity()
  }


}



